// apps/admin/src/lib/toast.ts
//
// P5 UI Polish W0 T5 — Sonner toast shim (spec §1.5).
//
// Why a shim? Call-sites should NOT import 'sonner' directly. This
// single file owns the Sonner contract; if we ever swap libs (or
// change defaults like position/duration), it's a one-file change
// instead of grepping every component. Same pattern displaycms uses
// for the AdminWS singleton (apps/admin/src/api/ws-admin.ts).
//
// Sonner default position is top-right; we override to bottom-right
// to match the existing PlayerCommandControls toast placement
// (spec §1.8 risk).

import { toast as sonnerToast } from 'sonner';

const DEFAULT_DURATION_MS = 4000;
const ERROR_DURATION_MS = 6000;

export const toast = {
  success(message: string, opts?: { id?: string }): void {
    sonnerToast.success(message, { duration: DEFAULT_DURATION_MS, ...opts });
  },
  error(message: string, opts?: { id?: string }): void {
    sonnerToast.error(message, { duration: ERROR_DURATION_MS, ...opts });
  },
  info(message: string, opts?: { id?: string }): void {
    sonnerToast.info(message, { duration: DEFAULT_DURATION_MS, ...opts });
  },
};

// Re-export the Sonner config the <Toaster /> needs. Imported by main.tsx.
export const TOASTER_CONFIG = {
  position: 'bottom-right' as const,
  duration: DEFAULT_DURATION_MS,
  closeButton: true,
};
